module.exports = __webpack_public_path__ + "static/media/hero-fashion.d3b9b86d.png";